import React from 'react';
import PropTypes from 'prop-types';
import { Paper, Typography, Avatar } from '@mui/material';

const styles = {
  root: {
    display: 'flex',
    gap: '24px',
    borderRadius: 5,
    height: '160px',
    padding: '35px',
    cursor: 'pointer',
  },
  avatar: {
    bgcolor: 'primary.main',
    width: '90px',
    height: '100%',
    borderRadius: 4,
  },
};

/**
 * Clickable MuiPaper to create a Big Button:
 *
 * @param {Object} props - Object. Component's props object.
 * @param {String} props.title - String. Shown title.
 * @param {String} props.subtitle - String. Shown subtitle.
 * @param {Function} props.onClick - Callback. onClick function provided from the parent component.
 * @param {String} props.bgcolor - String. Provided color for the avatar bgcolor property.
 * @param {React.JSX.Element} props.icon - React Element. Mui Icon component shown in the MuiAvatar component.
 *
 * @returns {React.JSX.Element}
 */

const BigButton = function BigButton({
  title = '',
  subtitle = '',
  onClick = () => {},
  bgcolor = 'info.light',
  icon = null,
  width = '520px',
}) {
  return (
    <Paper sx={{ ...styles.root, width }} onClick={onClick} elevation={3}>
      <Avatar sx={{ ...styles.avatar, bgcolor }} variant="rounded">
        {icon}
      </Avatar>
      <div style={{ display: 'flex', flexDirection: 'column', flexGrow: 1 }}>
        <Typography
          noWrap
          sx={{
            fontSize: "36px",
            fontWeight: 600
          }}>
          {title}
        </Typography>
        <Typography
          sx={{
            fontSize: "24px",
            fontWeight: 400,
            color: "greys.subtitle"
          }}>
          {subtitle}
        </Typography>
      </div>
    </Paper>
  );
};

BigButton.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  onClick: PropTypes.func,
  bgcolor: PropTypes.string,
  icon: PropTypes.object,
  width: PropTypes.string,
};

BigButton.defaultProps = {
  title: '',
  subtitle: '',
  onClick: () => {},
  bgcolor: 'info.light',
  icon: null,
};

export default BigButton;
